import React from 'react'
import { saveProject } from '../../store/actions/index';
import ProjectModal from './ProjectModal';

const CreateProjectModal = (props) => {

  const onSubmitAction = (values) => saveProject(values)

  const modalTitle = "Projekt anlegen";

  const initialValues = { title: '',
      building: '',
      street: '',
      zipcode: '',
      city: '',
      contact_name: '',
      contact_company: '',
      contact_email: '',
      contact_phone: '',
      customer_name: '',
      customer_company: '',
      customer_street: '',
      customer_zipcode: '',
      customer_phone: '',
      customer_country: '',
      customer_email: ''
    };

  return (
    <ProjectModal
      modalTitle={modalTitle}
      onSubmitAction={onSubmitAction}
      initialValues={initialValues}
    />
  )
}

export default CreateProjectModal



// WEBPACK FOOTER //
// ./src/components/Modals/CreateProjectModal.js